"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetInAppPromotionParams", {
    enumerable: true,
    get: function() {
        return GetInAppPromotionParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetInAppPromotionParams = _zod.z.object({
    promotionId: _utilsisomorphic.transformObjectId
});
